export const ATTENDANCE = '/attendance/'
export const ATTENDANCE_GROUP = `${ATTENDANCE}group`
export const ATTENDANCE_CSV = `${ATTENDANCE}import`
export const ATTENDANCE_MODULES = `${ATTENDANCE}modules`
export const ATTENDANCE_TABLE = `${ATTENDANCE}table`
export const ATTENDANCE_TABLE_STUDENT = `${ATTENDANCE_TABLE}/student`
export const ATTENDANCE_TABLE_MODULE = `${ATTENDANCE_TABLE}/module`
export const ATTENDANCE_QR_CODE = 'qr-attendance/qr-code'
